import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { installFetchInterceptor } from './utils/installFetchInterceptor';

// Catch expired-session 401s app-wide and force a clean re-login.
installFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// After your ReactDOM.render
serviceWorkerRegistration.register();